import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import LinkButton from "components/ui/LinkButton";

type PropsType = {
    readonly message: string;
};

function ErrorWhoAmI({ message }: PropsType) {
    return (
        <GridColumn>
            <GridItem>
                <GridRow justifyContent={"center"}>
                    <GridItem className={"col-xs-auto"} style={{ textAlign: "center" }}>
                        <h1>Errore tecnico</h1>

                        <p>{message}</p>
                    </GridItem>
                </GridRow>

                <GridRow justifyContent={"center"}>
                    <GridItem className={"col-xs-auto"}>
                        <LinkButton
                            variant={"contained"}
                            to={"/dashboard"}
                            label={"Ritorna alla dashboard"}
                        />
                    </GridItem>
                </GridRow>
            </GridItem>
        </GridColumn>
    );
}

export default ErrorWhoAmI;
